import { useState } from "react";

export type CalcHeightElement = HTMLElement | React.RefObject<HTMLElement | null>;
export type CalcHeightFn = (ref: CalcHeightElement) => void;

function useCalcHeight(maxHeight: number = 400) {
  const [height, setHeight] = useState<number>(maxHeight);

  const calcHeight: CalcHeightFn = (ref) => {
    let element: HTMLElement | null = null;
    if (ref instanceof HTMLElement) {
      element = ref;
    } else if (ref && "current" in ref) {
      element = ref.current;
    }

    if (element) {
      const contentHeight = element.offsetHeight;
      setHeight(contentHeight > maxHeight ? maxHeight : contentHeight + 20);
    }
  };

  return {
    height,
    setHeight,
    calcHeight,
  };
}

export default useCalcHeight;
